import { render } from "./askcollapse.vue?vue&type=template&id=5a75d79b&scoped=true"
import script from "./askcollapse.vue?vue&type=script&lang=js"
export * from "./askcollapse.vue?vue&type=script&lang=js"

import "./askcollapse.vue?vue&type=style&index=0&id=5a75d79b&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a75d79b"]])

export default __exports__